module.exports = __webpack_public_path__ + "static/media/seduce.8a154d8c.png";